import Backbone from "backbone";
import _ from "underscore";
import Form from "@grabyo/backbone-forms";

if (_.isUndefined(Backbone.Form)) {
    Backbone.Form = Form;
}

Backbone.View.prototype.destroy = function () {
    this.undelegateEvents();
    this.$el.removeData().unbind();
    this.remove();
    Backbone.View.prototype.remove.call(this);
};

Backbone.Model.prototype.reset = function (attrs) {
    attrs = _.isObject(attrs) ? attrs : {};
    this.clear();
    var newAttrs = _.extend(_.clone(this.defaults), attrs);
    this.set(newAttrs);
};

Backbone.Model.prototype.toJSON = function () {
    const attrs = _.clone(this.attributes);
    if (_.isString(this.idAttribute) && attrs[this.idAttribute]) {
        attrs.id = attrs[this.idAttribute];
    }
    return attrs;
};

Form.validators.errMessages.url = `Please enter a valid URL.`;

// Add some defaults
Form.editors.Checkbox.prototype.className = `grForm__input grForm__checkbox`;
Form.editors.Password.prototype.className = `grForm__input grForm__text`;
Form.editors.Select.prototype.className = `grForm__input grForm__select`;
Form.editors.Text.prototype.className = `grForm__input grForm__text`;
Form.editors.Number.prototype.className = `grForm__input grForm__text`;
Form.editors.TextArea.prototype.className = `grForm__input grForm__textarea`;

Backbone.BasicView = Backbone.View.extend({
    initialize: function (options = {}) {
        _.mapObject(
            options,
            function (val, key) {
                this[key] = val;
            },
            this
        );

        if (_.isString(options.template)) {
            this.template = _.template(options.template);
        } else if (_.isUndefined(this.template)) {
            throw `Backbone.BasicView requires \`template\``;
        }
    },

    render: function () {
        this.$el.html(this.template(_.result(this, `templateData`)));
        this.delegateEvents();
        return this;
    }
});

export default Backbone;
